// extracted by mini-css-extract-plugin
export default {"positive":"VarianceCell_positive__u8WnX","negative":"VarianceCell_negative__CzIZj"};